(function () {
  const EGG_SELECTOR = "[data-easter-egg]";
  const MODAL_ID = "easter-egg-modal";
  let modalSourceEgg = null;

  function ensureStyles() {
    if (document.getElementById("easter-egg-hunt-styles")) return;

    const style = document.createElement("style");
    style.id = "easter-egg-hunt-styles";
    style.textContent = `
      @keyframes easter-egg-wiggle {
        0%, 100% { transform: rotate(0deg); }
        12% { transform: rotate(10deg); }
        24% { transform: rotate(-10deg); }
        36% { transform: rotate(8deg); }
        48% { transform: rotate(-8deg); }
        60% { transform: rotate(5deg); }
        72% { transform: rotate(-5deg); }
        84% { transform: rotate(2deg); }
        92% { transform: rotate(-2deg); }
      }
      @keyframes easter-egg-break-top {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(-26deg); }
      }
      @keyframes easter-egg-break-bottom {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(26deg); }
      }
      @keyframes easter-egg-close-top {
        0% { transform: rotate(-26deg); }
        100% { transform: rotate(0deg); }
      }
      @keyframes easter-egg-close-bottom {
        0% { transform: rotate(26deg); }
        100% { transform: rotate(0deg); }
      }
      .easter-egg {
        width: var(--egg-size, 40px);
        height: var(--egg-size, 40px);
        padding: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
        line-height: 0;
        position: relative;
        z-index: 2;
        transform-origin: center center;
      }
      @media (hover: hover) and (pointer: fine) {
        @media (prefers-reduced-motion: no-preference) {
          .easter-egg:hover:not(.easter-egg--spent):not(.easter-egg--breaking):not(.easter-egg--closing) {
            animation: easter-egg-wiggle 0.42s ease-in-out;
          }
        }
      }
      .easter-egg__split {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
      .easter-egg__half {
        width: 100%;
        height: 50%;
        overflow: hidden;
        flex-shrink: 0;
        line-height: 0;
        will-change: transform;
      }
      .easter-egg__half--top {
        transform-origin: left bottom;
      }
      .easter-egg__half--bottom {
        transform-origin: left top;
      }
      .easter-egg__half img {
        width: 100%;
        height: 200%;
        max-height: none;
        display: block;
        object-fit: contain;
      }
      .easter-egg__half--bottom img {
        transform: translateY(-50%);
      }
      .easter-egg--breaking .easter-egg__half--top {
        animation: easter-egg-break-top 0.52s cubic-bezier(0.34, 1.2, 0.64, 1) forwards;
      }
      .easter-egg--breaking .easter-egg__half--bottom {
        animation: easter-egg-break-bottom 0.52s cubic-bezier(0.34, 1.2, 0.64, 1) forwards;
      }
      .easter-egg--spent:not(.easter-egg--closing) .easter-egg__half--top {
        transform: rotate(-26deg);
      }
      .easter-egg--spent:not(.easter-egg--closing) .easter-egg__half--bottom {
        transform: rotate(26deg);
      }
      .easter-egg--spent.easter-egg--closing .easter-egg__half--top {
        animation: easter-egg-close-top 0.45s cubic-bezier(0.34, 1, 0.64, 1) forwards;
      }
      .easter-egg--spent.easter-egg--closing .easter-egg__half--bottom {
        animation: easter-egg-close-bottom 0.45s cubic-bezier(0.34, 1, 0.64, 1) forwards;
      }
      .easter-egg--pixel-art .easter-egg__half img {
        image-rendering: pixelated;
        image-rendering: crisp-edges;
        image-rendering: -moz-crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
      .easter-egg-hunt-section {
        width: 100%;
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
      }
      html.easter-egg-modal-open {
        overflow: hidden;
      }
      body.easter-egg-modal-open {
        overflow: hidden;
        overscroll-behavior: none;
      }
      #${MODAL_ID} {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
        display: none;
        align-items: center;
        justify-content: center;
        padding: 16px;
        z-index: 99999;
      }
      #${MODAL_ID}.is-open {
        display: flex;
      }
      #${MODAL_ID} .easter-egg-modal__dialog {
        width: min(100%, 420px);
        background: #fff;
        border-radius: 12px;
        padding: 18px;
        text-align: center;
      }
      #${MODAL_ID} .easter-egg-modal__title {
        margin: 0 0 8px;
        font-size: 20px;
      }
      #${MODAL_ID} .easter-egg-modal__text {
        margin: 0 0 14px;
      }
      #${MODAL_ID} .easter-egg-modal__code {
        display: block;
        margin: 0 0 14px;
        padding: 10px 12px;
        background: #f7f7f7;
        border-radius: 8px;
        font-weight: 600;
        word-break: break-word;
      }
      #${MODAL_ID} .easter-egg-modal__actions {
        display: grid;
        grid-template-columns: 1fr;
        gap: 8px;
      }
      #${MODAL_ID} button {
        border: 0;
        border-radius: 8px;
        padding: 10px 14px;
        cursor: pointer;
      }
      #${MODAL_ID} .easter-egg-modal__copy {
        background: #434e3e;
        color: #fff;
      }
      #${MODAL_ID} .easter-egg-modal__close {
        background: #ececec;
        color: #1d1d1d;
      }
      @media (min-width: 768px) {
        #${MODAL_ID} .easter-egg-modal__actions {
          grid-template-columns: 1fr 1fr;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function lockBodyScroll() {
    document.documentElement.classList.add("easter-egg-modal-open");
    document.body.classList.add("easter-egg-modal-open");
  }

  function unlockBodyScroll() {
    document.documentElement.classList.remove("easter-egg-modal-open");
    document.body.classList.remove("easter-egg-modal-open");
  }

  function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = MODAL_ID;
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.innerHTML = `
      <div class="easter-egg-modal__dialog">
        <h3 class="easter-egg-modal__title">You found one!</h3>
        <p class="easter-egg-modal__text"></p>
        <code class="easter-egg-modal__code"></code>
        <div class="easter-egg-modal__actions">
          <button type="button" class="easter-egg-modal__copy">Copy code</button>
          <button type="button" class="easter-egg-modal__close">Close</button>
        </div>
      </div>
    `;

    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        closeRewardModal();
      }
    });

    modal.querySelector(".easter-egg-modal__close").addEventListener("click", function () {
      closeRewardModal();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        const m = document.getElementById(MODAL_ID);
        if (m && m.classList.contains("is-open")) {
          closeRewardModal();
        }
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function showReward(options, egg) {
    modalSourceEgg = egg || null;
    const modal = ensureModal();
    modal.querySelector(".easter-egg-modal__text").textContent = options.message;
    modal.querySelector(".easter-egg-modal__code").textContent = options.code || "No coupon configured";

    const copyButton = modal.querySelector(".easter-egg-modal__copy");
    copyButton.textContent = "Copy code";
    copyButton.onclick = function () {
      if (!options.code) return;
      navigator.clipboard.writeText(options.code).then(function () {
        copyButton.textContent = "Copied!";
      });
    };

    modal.classList.add("is-open");
    lockBodyScroll();
  }

  function closeRewardModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal || !modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    unlockBodyScroll();

    const egg = modalSourceEgg;
    modalSourceEgg = null;
    if (!egg || !egg.classList.contains("easter-egg--spent")) return;

    const reducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reducedMotion || !egg.querySelector(".easter-egg__split")) {
      egg.classList.remove("easter-egg--spent");
      return;
    }

    egg.classList.add("easter-egg--closing");
    const topHalf = egg.querySelector(".easter-egg__half--top");
    let done = false;
    function finishClose() {
      if (done) return;
      done = true;
      egg.classList.remove("easter-egg--spent", "easter-egg--closing");
    }
    if (topHalf) {
      topHalf.addEventListener("animationend", finishClose, { once: true });
    }
    window.setTimeout(finishClose, 600);
  }

  function handleEggClick(egg) {
    if (egg.dataset.eggBreaking === "true" || egg.classList.contains("easter-egg--closing")) return;

    const couponCode = egg.dataset.couponCode || "";
    const message = egg.dataset.message || "You found an easter egg!";
    const options = { message: message, code: couponCode };

    if (egg.classList.contains("easter-egg--spent")) {
      showReward(options, egg);
      return;
    }

    const split = egg.querySelector(".easter-egg__split");
    const reducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!split || reducedMotion) {
      egg.classList.add("easter-egg--spent");
      showReward(options);
      return;
    }

    egg.dataset.eggBreaking = "true";
    egg.classList.add("easter-egg--breaking");

    const topHalf = egg.querySelector(".easter-egg__half--top");
    let finished = false;

    function finishBreak() {
      if (finished) return;
      finished = true;
      egg.dataset.eggBreaking = "";
      egg.classList.remove("easter-egg--breaking");
      egg.classList.add("easter-egg--spent");
      showReward(options, egg);
    }

    if (topHalf) {
      topHalf.addEventListener("animationend", finishBreak, { once: true });
    }
    window.setTimeout(finishBreak, 700);
  }

  function initEgg(egg) {
    if (egg.dataset.eggBound === "true") return;
    egg.dataset.eggBound = "true";
    egg.addEventListener("click", function () {
      handleEggClick(egg);
    });
  }

  function init() {
    ensureStyles();
    ensureModal();
    document.querySelectorAll(EGG_SELECTOR).forEach(initEgg);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
